import { hasNoLicense, type App } from '../api/appsApi';

const { REACT_APP_CODEX_PLATFORM_TEMPLATE_URL } = process.env;

export type DigibookApp = App & {
  platformType: 'P intern';
  linkedApp?: {
    type: 'digibook';
  };
  platformLinkType: 'digibook';
  platformUrl: never;
};

export type OldDigibookApp = App & {
  platformType: 'P intern';
  appType: {
    isDigibook: true;
  };
  platformLinkType: never;
  platformUrl?: string;
};

export function isDigibookApp(app: App): app is DigibookApp {
  return Boolean(app.platformType === 'P intern' && app.platformLinkType === 'digibook');
}

export function isOldDigibookApp(app: App): app is OldDigibookApp {
  return Boolean(app.platformType === 'Web extern' && app.appType.isDigibook);
}

type DisabledState = 'notDisabled' | 'noLicense' | 'preview';

export const getDisabledState = (digibookApp: App): DisabledState => {
  if (hasNoLicense(digibookApp)) {
    if (digibookApp.state === 'preview') return 'preview';
    return 'noLicense';
  }

  return 'notDisabled';
};

export const getDigibookTooltip = (disabledState: DisabledState): string => {
  if (disabledState === 'noLicense') {
    return 'PAGES.TOC_LEVEL.APPS.DIGIBOOK.NO_LICENSE_TOOLTIP';
  }

  return 'PAGES.TOC_LEVEL.APPS.DIGIBOOK.PREVIEW_TOOLTIP';
};

interface BuildCodexUrlParams {
  digibookId: string;
  moduleId: string;
  accountProvider?: string;
  page?: number;
}

export const buildCodexUrl = ({ digibookId, moduleId, accountProvider, page }: BuildCodexUrlParams) => {
  const provider = accountProvider || 'pelckmans';

  const url = REACT_APP_CODEX_PLATFORM_TEMPLATE_URL.replace(':provider', provider)
    .replace(':id', digibookId)
    .concat(page ? `/${page}` : '');

  const q = new URLSearchParams({
    superModuleId: moduleId,
  });

  return `${url}?${q}`;
};
